import { css } from 'styled-system/css';
import { NativeFormula } from './NativeFormula';

export function FormulaOverlay({ open }: { open: boolean }) {
  return (
    <div
      data-open={open || undefined}
      className={css({
        position: 'absolute',
        top: '0',
        left: '48px',
        zIndex: 3,
        width: '280px',
        display: 'grid',
        gridTemplateRows: '0fr',
        transition: 'grid-template-rows 400ms {easings.out}',
        pointerEvents: 'none',
        _motionReduce: { transition: 'none' },
        '&[data-open]': { gridTemplateRows: '1fr' },
      })}
    >
      <div
        className={css({
          overflow: 'hidden',
          minHeight: 0,
        })}
      >
        <div
          className={css({
            position: 'relative',
            background: 'bg.surface',
            border: '1px solid token(colors.border.focus)',
            boxShadow: 'lg',
            padding: '2.5',
            paddingRight: '8',
            fontFamily: 'mono',
            fontSize: 'xs',
            lineHeight: 'snug',
          })}
        >
          <pre
            className={css({
              margin: 0,
              fontFamily: 'inherit',
              fontSize: 'inherit',
              lineHeight: 'inherit',
            })}
          >
            <NativeFormula />
          </pre>
        </div>
      </div>
    </div>
  );
}
